import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal } from '@mui/material';

import LoaderQrIcon from '~/assets/icons/svgs/loader-qr.svg?react';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

export const QRPreviewBar = ({ isOpen, onClose, qrImageUrl, isQrLoading }) => {
  const { t } = useTranslation();

  const styles = useStyles();

  const [isQrImageLoaded, setIsQrImageLoaded] = useState(false);

  useEffect(() => {
    if (qrImageUrl && isQrImageLoaded) {
      setIsQrImageLoaded(false);
    }
  }, [qrImageUrl]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      sx={styles.modal}
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
    >
      <Box sx={styles.container}>
        <IconButton onClick={onClose} sx={styles.closeIconWrapper}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>

        <Text variant="h2" sx={styles.title}>
          QR {t('createQrStep1:preview')}
        </Text>
        <img src={qrImageUrl} alt="" onLoad={() => setIsQrImageLoaded(true)} style={{ display: 'none' }} />

        <Box sx={styles.qrContainer}>
          {isQrLoading || !isQrImageLoaded ? (
            <LoaderQrIcon />
          ) : (
            <img width="100%" src={qrImageUrl} alt="QR image" height="100%" />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

const useStyles = () => {
  return {
    container: css`
      width: calc(100dvw - 32px);
      padding: 20px 20px 40px;
      border-radius: 16px;
      background-color: ${COLORS.white};
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    backdrop: css`
      background-color: #c9c8c84d;
      backdrop-filter: blur(3px);
    `,
    modal: css`
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    closeIcon: css`
      color: ${COLORS.textMain};
    `,
    closeIconWrapper: css`
      margin-left: auto;
    `,
    title: css`
      text-align: center;
      margin-bottom: 24px;
    `,
    qrContainer: css`
      width: 100%;
      max-width: 285px;
      padding: 28px;
      border-radius: 20px;
      border: 1px solid ${COLORS.grey200};
      min-height: 290px;
    `,
  };
};
